export default __webpack_public_path__ + "static/anne-e0457ca648cf02107777ce9d0a4a4a45.webp";